import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 3.792A5.7 5.7 0 0 1 12.145 7 5.693 5.693 0 0 1 7 10.208 5.693 5.693 0 0 1 1.855 7 5.7 5.7 0 0 1 7 3.792Zm0-1.167A6.899 6.899 0 0 0 .583 7 6.899 6.899 0 0 0 7 11.375 6.899 6.899 0 0 0 13.417 7 6.899 6.899 0 0 0 7 2.625Zm0 2.917a1.459 1.459 0 1 1-.001 2.917A1.459 1.459 0 0 1 7 5.542Zm0-1.167A2.629 2.629 0 0 0 4.375 7 2.629 2.629 0 0 0 7 9.625 2.629 2.629 0 0 0 9.625 7 2.629 2.629 0 0 0 7 4.375Z",
    fill: "#1E92EF"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h14v14H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };